// "Differences only" view of an Operators audit entry: pure helpers shared by the
// audit entry component (global log and per-operator history).

// deep-diff of old vs new: one row per changed leaf path. Arrays compare as leaves
// (a tag list reads better as one before/after than as index-level noise)
export function auditDiffRows(entry) {
	const rows = []
	const walk = (oldValue, newValue, path) => {
		if (JSON.stringify(oldValue) === JSON.stringify(newValue)) return
		const bothPlainObjects = oldValue && newValue
			&& typeof oldValue === 'object' && typeof newValue === 'object'
			&& !Array.isArray(oldValue) && !Array.isArray(newValue)
		if (bothPlainObjects) {
			for (const key of new Set([ ...Object.keys(oldValue), ...Object.keys(newValue) ])) {
				walk(oldValue[key], newValue[key], path ? `${ path }.${ key }` : key)
			}
			return
		}
		rows.push({ path: path || '·', oldValue, newValue })
	}
	walk(entry.oldData ?? {}, entry.newData ?? {}, '')
	return rows
}

export function formatDiffValue(value) {
	if (value === undefined) return '—'
	return JSON.stringify(value, null, 1)
}

const SECTION_OF = { applications: 'myServices', tags: 'myServices', contentHub: 'contentHub', reportCenter: 'reportCenter', peaksolution: 'peaksolution' }
const SECTION_ORDER = [ 'myServices', 'contentHub', 'reportCenter', 'peaksolution' ]

// changed rows grouped into the dialog's four sections (MyServices grants live at the
// top level of the payload) in a fixed order — the stored jsonb does not preserve key
// order, so without this, top-level rows drift under whatever header came before them
export function auditDiffGroups(entry) {
	const groups = []
	for (const row of auditDiffRows(entry)) {
		const dot = row.path.indexOf('.')
		const topKey = dot > 0 ? row.path.slice(0, dot) : row.path
		const name = SECTION_OF[topKey] ?? topKey
		const sub = name === 'myServices' ? row.path : (dot > 0 ? row.path.slice(dot + 1) : '')
		let group = groups.find(g => g.name === name)
		if (!group) groups.push(group = { name, rows: [] })
		group.rows.push({ ...row, sub })
	}
	return groups.sort((a, b) => {
		const ai = SECTION_ORDER.indexOf(a.name), bi = SECTION_ORDER.indexOf(b.name)
		return (ai === -1 ? SECTION_ORDER.length : ai) - (bi === -1 ? SECTION_ORDER.length : bi)
	})
}
